// Account API
import ajax from './_ajax';

const api = {};
api.addBusinessContact = function (params) {
  return ajax.post('/api/BusinessContact/AddBusinessContact', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/businessContactApi.js